import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Dépense déclarée par le Personnel (achat sur le terrain, réception de stock), en attente de validation */
export interface DepenseTerrain {
  id: number;
  statut: 'EN_ATTENTE' | 'VALIDEE' | 'REFUSEE';
  /** DECLARATION | RECEPTION */
  origine?: string;
  nature?: string;
  categorie?: string;
  /** FCFA ; null possible pour une réception (bon de livraison sans prix) */
  montant?: number | null;
  fournisseur?: string;
  date?: string;
  note?: string;
  lienLabel?: string;
  /** Photo de la facture ou du bon de livraison (GED) */
  documentId?: number;
  articleNom?: string;
  quantite?: number;
  unite?: string;
  auteurNom?: string;
  creeLe?: string;
  traiteePar?: string;
  motif?: string;
}

/** Corrections facultatives à la validation (montant exigé s'il manquait) */
export interface CorrectionsDepense { montant?: number | null; categorie?: string; fournisseur?: string; date?: string; }

@Injectable({ providedIn: 'root' })
export class DepensesTerrainService {

  private readonly base = `${environment.BASE_URL}/api/depenses-terrain`;

  constructor(private http: HttpClient) {}

  liste(statut = 'EN_ATTENTE'): Observable<DepenseTerrain[]> {
    return this.http.get<DepenseTerrain[]>(this.base, { params: { statut } });
  }

  compte(): Observable<{ enAttente: number }> {
    return this.http.get<{ enAttente: number }>(`${this.base}/compte`);
  }

  valider(id: number, c?: CorrectionsDepense): Observable<DepenseTerrain> {
    return this.http.post<DepenseTerrain>(`${this.base}/${id}/valider`, c || {});
  }

  refuser(id: number, motif: string): Observable<DepenseTerrain> {
    return this.http.post<DepenseTerrain>(`${this.base}/${id}/refuser`, { motif });
  }
}
